import React, { useEffect, useRef, useState } from "react"
import "keen-slider/keen-slider.min.css"
import Module from "../components/Module"
import { makeStyles } from "@material-ui/core/styles"
import theme from "../site/theme"
import { Box, Grid, Container, useMediaQuery } from "@material-ui/core"
import ReactPlayerSoundcloud from "react-player/soundcloud"
import ReactPlayer from "react-player"
import Typography from "@material-ui/core/Typography"
import FluidImage from "../components/FluidImage"
import Icon from "../components/Icon"
import Text from "../components/Text"

const useStyles = makeStyles(theme => ({
  mediaBox: {
    position: "relative",
    marginTop: theme.spacing(3),
  },
  mediaBoxLogo: {
    width: 180,
    margin: "0 auto",
    display: "block",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      maxWidth: 220,
      maxHeight: 150,
      width: "auto",
    },
  },
  mediaBoxContent: {
    position: "relative",
    height: "100%",
  },
  mediaBoxTextContent: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    top: "10%",
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
  mediaContainer: {
    paddingRight: "16px !important",
    paddingLeft: "16px !important",
  },
  iconPlay: {
    width: 56,
    height: 56,
    [theme.breakpoints.down("md")]: {
      width: 32,
      height: 32,
    },
  },
  moreWidth: {
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
  },
  mediaBoxTitle: {
    textAlign: "center",
    fontSize: 35.2,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.704px;",
    color: "black",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontFamily: "Spezia",
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
      fontWeight: 600,
      marginBottom: theme.spacing(2),
    },
  },
  mediaBoxDescription: {
    paddingRight: 8,
    paddingLeft: 8,
    marginRight: 80,
    marginLeft: 80,
    marginTop: 40,
    marginBottom: 40,
    fontFamily: "Spezia",
    [theme.breakpoints.down("md")]: {
      marginRight: 0,
      marginLeft: 0,
      marginTop: 16,
      marginBottom: 16,
    },
  },
  mediaBoxAudioContainer: {
    width: "100%",
    height: 160,
  },
  mediaBoxAudioTitle: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: "Spezia",
    display: "block",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      fontSize: 20,
    },
  },
  mediaBoxVideoContainer: {
    width: "100%",
    height: "230px",
    [theme.breakpoints.up("md")]: {
      height: "70vh",
    },
    [theme.breakpoints.up("lg")]: {
      height: "500px",
    },
  },
  mediaBoxVideoContainerChat: {
    width: "100%",
    minHeight: "60vh",
    position: "relative",
    backgroundColor: theme.palette.grey?.[100] || "#f5f5f5",
    [theme.breakpoints.up("md")]: {
      minHeight: 500,
    },
    "& #chat-embed-wrapper": {
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      "& iframe": {
        height: "100%",
        width: "100%",
      },
    },
  },
  noVideo: {
    width: "100%",
    height: "100%",
    "& img": {
      height: "100%",
      width: "100%",
      objectFit: "cover",
    },
  },
  mediaBoxBg: {
    position: "absolute",
    left: 0,
    zIndex: 1,
    maxHeight: 320,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    top: "calc(10% * var(--top-offset) / 100)",
    [theme.breakpoints.up("md")]: {
      maxHeight: "90vh",
    },
    [theme.breakpoints.up("lg")]: {
      maxHeight: "70vh",
    },
    [theme.breakpoints.up("lg")]: {
      maxHeight: 500,
    },
    "& img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      height: "100%",
      width: "100%",
      objectFit: "cover",
      objectPosition: "top left",
    },
  },
  mediaBoxContentLEFT: {
    height: "100%",
    position: "relative",
  },
  mediaBoxContentRIGHT: {
    height: "100%",
    position: "relative",
  },
  contentContainer: {
    position: "relative",
    zIndex: 2,
    top: "10%",
    margin: "0 auto",
    padding: `${theme.spacing(0, 4)} !important`,
    boxSizing: "border-box",
    "&.has-image": {
      padding: `${theme.spacing(4)}px !important`,
      [theme.breakpoints.down("sm")]: {
        padding: `${theme.spacing(0, 2, 2, 2)} !important`,
      },
    },
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing(0, 2, 2, 2)} !important`,
    },
  },
  contentWrapperLEFT: {
    display: "flex",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 0,
    },
  },
  contentWrapperRIGHT: {
    display: "flex",
    gap: theme.spacing(4),
    flexDirection: "row-reverse",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 0,
    },
  },
  videoContainer: {
    padding: theme.spacing(2, 0),
    minWidth: "60%",
    width: "100%",
    height: "fit-content",
    aspectRatio: "16/9",
    [theme.breakpoints.down("sm")]: {
      paddingTop: 0,
      minWidth: "100%",
    },
  },
  textContent: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    textAlign: "start",
    marginTop: 0,
    marginBottom: theme.spacing(2),
    fontSize: 35.2,
    fontWeight: 700,
    letterSpacing: "-0.704px;",
    lineHeight: 1.2,
    fontFamily: "Spezia",
    color: "black",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      fontWeight: 600,
      textAlign: "center",
      marginTop: theme.spacing(2),
    },
  },
  description: {
    fontFamily: "Spezia",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  background: {
    position: "absolute",
    left: 0,
    zIndex: 1,
    width: "100%",
    overflow: "hidden",
    top: "calc(10% * var(--top-offset) / 100)",
    "& img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      height: "100%",
      width: "100%",
      objectFit: "cover",
      objectPosition: "top left",
    },
  },
}))

const MediaBoxModule = props => {
  const classes = useStyles()
  const [top, setTop] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [videoHeight, setVideoHeight] = useState(0)
  const imgRef = useRef()
  const videoRef = useRef()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const {
    link_youtube,
    link_sound_cloud,
    description,
    title,
    logo,
    image,
    thumbnail_image,
    text_sound_cloud,
    info,
    has_chat,
    media_position,
  } = props

  useEffect(() => {
    if (imgRef.current) {
      setTop(imgRef.current.offsetTop)
    }
  }, [imgRef])

  useEffect(() => {
    if (has_chat?.field_value) {
      function extractVideoID(url) {
        const regExp =
          /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
        const match = url?.match(regExp)
        return match && match[7].length === 11 ? match[7] : null
      }

      const frame = document.createElement("iframe")
      frame.referrerPolicy = "origin"
      frame.src = `https://www.youtube.com/live_chat?v=${extractVideoID(
        link_youtube?.field_value?.href
      )}&embed_domain=${window.location.hostname}`
      frame.frameBorder = "0"
      frame.id = "chat-embed"
      const wrapper = document.getElementById("chat-embed-wrapper")

      if (wrapper?.children.length) {
        wrapper.removeChild(wrapper.children[0])
      }
      wrapper?.appendChild(frame)
    }
  }, [has_chat?.field_value, link_youtube?.field_value?.href])

  // Determine media position class
  const mediaPositionClass = media_position?.field_value
    ? `MediaBox--${media_position.field_value.toLowerCase()}`
    : "MediaBox--center"

  useEffect(() => {
    if (videoRef.current) {
      const updateHeight = () => {
        const height = videoRef.current.offsetHeight
        setVideoHeight(height + (isMobile ? 80 : 64))
      }
      updateHeight()
      const observer = new ResizeObserver(updateHeight)
      observer.observe(videoRef.current)

      return () => observer.disconnect()
    }
  }, [videoRef])

  const handleVideoClick = () => setIsPlaying(true)

  const renderVideo = () => (
    <div
      className={
        media_position?.field_value === "CENTER"
          ? classes.mediaBoxVideoContainer
          : classes.videoContainer
      }
      onClick={handleVideoClick}
      ref={videoRef}
    >
      {link_youtube?.field_value?.href ? (
        <ReactPlayer
          url={link_youtube?.field_value.href}
          light={thumbnail_image?.field_value?.src || ""}
          playing={isPlaying}
          playIcon={
            <Icon className={classes.iconPlay} name="play_tangerine_bg" />
          }
          width="100%"
          height="100%"
          controls
          config={{
            youtube: {
              embedOptions: {
                host: "https://www.youtube-nocookie.com",
              },
            },
          }}
        />
      ) : (
        <FluidImage
          className={classes.noVideo}
          {...thumbnail_image?.field_value}
        />
      )}
    </div>
  )

  const renderBackground = () => (
    <div
      style={
        media_position?.field_value === "CENTER"
          ? { "--top-offset": top }
          : { "--top-offset": top, height: `${videoHeight}px` }
      }
      className={
        media_position?.field_value === "CENTER"
          ? classes.mediaBoxBg
          : classes.background
      }
    >
      <FluidImage {...image?.field_value} />
    </div>
  )

  return (
    <Module
      className={`${classes.mediaBox} ${mediaPositionClass}`}
      id={has_chat?.field_value ? "media_box_live" : "media_box"}
      variant="full"
    >
      <FluidImage className={classes.mediaBoxLogo} {...logo?.field_value} />
      {media_position?.field_value === "CENTER" ? (
        <Box className={classes.mediaBoxContent}>
          <Box
            className={`${classes.mediaBoxTextContent} ${
              has_chat?.field_value ? classes.moreWidth : ""
            }`}
          >
            <Container className={classes.mediaContainer} maxWidth="lg">
              <Grid container>
                <Grid item xs={12}>
                  <Typography component="h2" className={classes.mediaBoxTitle}>
                    {title?.field_value}
                  </Typography>
                </Grid>
                <Grid container>
                  {!has_chat?.field_value ||
                  !link_youtube?.field_value?.href ? (
                    <Grid item xs={12}>
                      {renderVideo()}
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12} md={8}>
                        {renderVideo()}
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className={classes.mediaBoxVideoContainerChat}>
                          <div id="chat-embed-wrapper" />
                        </Box>
                      </Grid>
                    </>
                  )}
                  <Grid
                    item
                    xs={12}
                    md={link_sound_cloud?.field_value?.href ? 7 : 12}
                  >
                    <Text
                      className={`${classes.mediaBoxDescription} ${
                        link_sound_cloud?.field_value?.href
                          ? "text-left"
                          : "text-center"
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: description?.field_value,
                      }}
                    />
                  </Grid>
                  {link_sound_cloud?.field_value?.href && (
                    <Grid item xs={12} md={5}>
                      <Box
                        padding={theme.spacing(0.5)}
                        marginY={theme.spacing(1)}
                        marginTop={theme.spacing(5)}
                      >
                        <Typography
                          component="span"
                          className={classes.mediaBoxAudioTitle}
                        >
                          {text_sound_cloud?.field_value}
                          {link_sound_cloud?.field_value.label}
                        </Typography>
                        <Box className={classes.mediaBoxAudioContainer}>
                          <ReactPlayerSoundcloud
                            playIcon={
                              <Icon className="icon-32">
                                video-play-magenta
                              </Icon>
                            }
                            className="audio-player"
                            url={link_sound_cloud?.field_value.href}
                            width="100%"
                            height="100%"
                            light={thumbnail_image?.field_value?.src || ""}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Container>
          </Box>
          {image?.field_value && renderBackground()}
        </Box>
      ) : (
        <div
          className={classes[`mediaBoxContent${media_position.field_value}`]}
        >
          <Container
            className={`${classes.contentContainer} ${
              image?.field_value ? "has-image" : ""
            }`}
          >
            <Box
              className={classes[`contentWrapper${media_position.field_value}`]}
            >
              {isMobile && (
                <Typography component="h2" className={classes.title}>
                  {title?.field_value}
                </Typography>
              )}
              {renderVideo()}
              <Box className={classes.textContent}>
                {!isMobile && (
                  <Typography component="h2" className={classes.title}>
                    {title?.field_value}
                  </Typography>
                )}
                <Text
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: description?.field_value }}
                />
              </Box>
            </Box>
          </Container>
          {image?.field_value && renderBackground()}
        </div>
      )}
    </Module>
  )
}

export default MediaBoxModule
